import React from 'react';
import PropTypes from 'prop-types';
import parseHTML from 'html-react-parser';

/**
 * RenderHTML:
 *  - Component renders any passed HTML to the dom.
 */
export function RenderHTML({content, replace}) {
  if (replace) {
    return <>{parseHTML(content, {replace})}</>;
  } else {
    return <>{parseHTML(content)}</>;
  }
}
RenderHTML.propTypes = {
  /**
   * HTML content to be rendered to DOM passed in as string
   */
  content: PropTypes.string.isRequired,
  /**
   * Function to replace the domNode with an other
   */
  replace: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.func]),
};

RenderHTML.defaultProps = {
  content: '<p>Hello World</p>',
  replace: null,
};
